export default "__VITE_ASSET__B8v6QrCz__"